class CountrySelector extends HTMLElement {
  connectedCallback() {
    this._activeEl = this.querySelector('.active_country_li');
    if (!this._activeEl) return;

    this._init();
    this._boundExternalChange = this._onExternalChange.bind(this);
    document.addEventListener('country:change', this._boundExternalChange);
  }

  disconnectedCallback() {
    document.removeEventListener('country:change', this._boundExternalChange);
  }

  _init() {
    const activeCode = this._activeEl.dataset.country;
    if (activeCode) this._updateMarketBlocks(activeCode);

    this._activeEl.addEventListener('click', () => {
      this.querySelector('.country_ul_outer')?.classList.toggle('open_country');
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.querySelector('.country_ul_outer')?.classList.remove('open_country');
      }
    });

    this.querySelectorAll('.country_li').forEach(li => {
      li.addEventListener('click', e => {
        e.stopPropagation();
        const ulOuter = e.target.closest('.country_ul_outer');
        ulOuter?.classList.remove('open_country');

        const code = li.dataset.country;
        this._activeEl.innerHTML = li.innerHTML;
        this._activeEl.dataset.country = code;
        this._updateMarketBlocks(code);

        document.dispatchEvent(new CustomEvent('country:change', {
          detail: { code, source: this }
        }));
      });
    });
  }

  _updateMarketBlocks(code) {
    const scope = this.closest('.shipping-section-content') || this.closest('.trust-tab-content') || document;
    scope.querySelectorAll('.market-block').forEach(block => {
      block.classList.toggle('hidden', block.dataset.country !== code);
    });
  }

  _onExternalChange(e) {
    if (e.detail.source === this) return;
    const code = e.detail.code;

    const matchingLi = this.querySelector(`.country_li[data-country="${code}"]`);
    if (matchingLi && this._activeEl) {
      this._activeEl.innerHTML = matchingLi.innerHTML;
      this._activeEl.dataset.country = code;
    }
    this._updateMarketBlocks(code);
  }
}

customElements.define('country-selector', CountrySelector);
